import request from "@/utils/request";
// import { encryptByDES } from '@/utils/crypto'
import qs from "qs";
import axios from "axios";
const BASE_API = process.env.VUE_APP_BASE_API;
const LOGIN_API = process.env.VUE_APP_LOGIN_API;

export function getBrands(param) {
  return request({
    url: `${BASE_API}/api/brands`,
    method: "get",
    params: param,
  });
}
